export const validateTerminalUsingMot = (mot,isImportShipment) => isImportShipment?["1","8"]?.includes(mot): mot=="1"
export const defaultTransMode = { '1': '11', '3': '30', '4': '40', '8': '81' }
export const getJobStates = (jobWheels) =>  (wheelName) => jobWheels?.[wheelName]?.value?.state || ''
export const isPreferenceOriginDisabled = (procedure='') => ['10','11','21','22','23','31','76','77'].some(startCode => procedure.startsWith(startCode))

export const procedureValidationMapping = {
    B1: ['10', '11', '23', '31'],
    B2: ['21', '22'],
    B3: ['76', '77'],
    B4: ['10'],
    C1: ['10', '11', '23', '31'],
    C2: [],
}

export const transmissionMapping = () => ({
    NEW: {
        decTypes: null,
        procedures: ['B1', 'B2', 'B3', 'B4', 'C1'],
        customStates: ['STATE_DMS_NONE', 'STATE_DMS_515CRE','STATE_DMS_515SENT', 'STATE_DMS_515REJ'],
    },
    SUP: {
        decTypes: ['B', 'C', 'E', 'F'],
        procedures: ['B1', 'B2', 'B3', 'B4', 'C1'],
        customStates: ['STATE_DMS_529ROG', 'STATE_DMS_531REM', 'STATE_DMS_SUPREJ', 'STATE_DMS_RRDREM'],
    },
    CAN: {
        decTypes: null,
        procedures: ['B1', 'B2', 'B3', 'B4', 'C1'],
        customStates: [
            'STATE_DMS_511ACK', 'STATE_DMS_511SENT', 'STATE_DMS_511REJ',
            'STATE_DMS_511REJ', 'STATE_DMS_528ACC', 'STATE_DMS_560CTL10',
            'STATE_DMS_560CTL20', 'STATE_DMS_560CTL30', 'STATE_DMS_560CTL40',
            'STATE_DMS_560CTL41', 'STATE_DMS_560CTL42', 'STATE_DMS_560CTL43',
            'STATE_DMS_560CTL44', 'STATE_DMS_560CTL45', 'STATE_DMS_560CTL50',
            'STATE_DMS_529ROG', 'STATE_DMS_529CLE', 'STATE_DMS_582REM',
            'STATE_DMS_583SENT', 'STATE_DMS_583ACK', 'STATE_DMS_583REJ',
            'STATE_DMS_583RCV', 'STATE_DMS_509CAN', 'STATE_DMS_SUPSENT',
            'STATE_DMS_SUPACK', 'STATE_DMS_SUPRCV', 'STATE_DMS_SUPREJ',
            'STATE_DMS_531REM', 'STATE_DMS_AMD', 'STATE_DMS_RFI',
            'STATE_DMS_RRDREM', 'STATE_DMS_CRESENT', 'STATE_DMS_CREACK',
            'STATE_DMS_CREREJ', 'STATE_DMS_CRERCV', 'STATE_DMS_514REJ',
            'STATE_DMS_513SENT', 'STATE_DMS_513ACK', 'STATE_DMS_513REJ',
            'STATE_DMS_513REJ', 'STATE_DMS_513RCV', 'STATE_DMS_504ACC',
            'STATE_DMS_AMD', 'STATE_DMS_513REJ'
        ],
        entryStates:['STATE_ENTRY_ACCEPTED', 'STATE_ENTRY_RELEASED', 'STATE_ENTRY_AMEND_ACCEPTED']
    },
    MOD: {
        decTypes: null,
        procedures: ['B1', 'B2', 'B3', 'B4', 'C1'],
        customStates: ['STATE_DMS_511ACK', 'STATE_DMS_511SENT', 'STATE_DMS_511REJ',
            'STATE_DMS_511REJ', 'STATE_DMS_528ACC', 'STATE_DMS_560CTL10',
            'STATE_DMS_560CTL20', 'STATE_DMS_560CTL30', 'STATE_DMS_560CTL40',
            'STATE_DMS_560CTL41', 'STATE_DMS_560CTL42', 'STATE_DMS_560CTL43',
            'STATE_DMS_560CTL44', 'STATE_DMS_560CTL45', 'STATE_DMS_560CTL50',
            'STATE_DMS_529ROG', 'STATE_DMS_529CLE', 'STATE_DMS_582REM',
            'STATE_DMS_583SENT', 'STATE_DMS_583ACK', 'STATE_DMS_583REJ',
            'STATE_DMS_583RCV', 'STATE_DMS_509CAN', 'STATE_DMS_SUPSENT',
            'STATE_DMS_SUPACK', 'STATE_DMS_SUPRCV', 'STATE_DMS_SUPREJ',
            'STATE_DMS_531REM', 'STATE_DMS_AMD', 'STATE_DMS_RFI',
            'STATE_DMS_RRDREM', 'STATE_DMS_CRESENT', 'STATE_DMS_CREACK',
            'STATE_DMS_CREREJ', 'STATE_DMS_CRERCV', 'STATE_DMS_514REJ',
            'STATE_DMS_513REJ', 'STATE_DMS_513REJ', 'STATE_DMS_513RCV',
            'STATE_DMS_504ACC', 'STATE_DMS_AMD', 'STATE_DMS_513REJ'
        ],
    },
    CRE: {
        decTypes: null,
        procedures: ['B1', 'B2', 'B3', 'B4', 'C1'],
        customStates: [
            'STATE_DMS_528ACC', 'STATE_DMS_560CTL10', 'STATE_DMS_560CTL20',
            'STATE_DMS_560CTL30', 'STATE_DMS_560CTL40', 'STATE_DMS_560CTL41',
            'STATE_DMS_560CTL42', 'STATE_DMS_560CTL43', 'STATE_DMS_560CTL44',
            'STATE_DMS_560CTL45', 'STATE_DMS_560CTL50', 'STATE_DMS_529ROG',
            'STATE_DMS_509CAN', 'STATE_DMS_SUPSENT', 'STATE_DMS_SUPACK',
            'STATE_DMS_SUPRCV', 'STATE_DMS_SUPREJ', 'STATE_DMS_531REM',
            'STATE_DMS_AMD', 'STATE_DMS_RFI', 'STATE_DMS_RRDREM',
            'STATE_DMS_CREREJ', 'STATE_DMS_514REJ', 'STATE_DMS_513SENT',
            'STATE_DMS_513ACK', 'STATE_DMS_513REJ', 'STATE_DMS_513RCV',
            'STATE_DMS_504ACC','STATE_DMS_NL_RRD'
        ],
    },
    EXT: {
        decTypes: null,
        procedures: ['B1', 'B2', 'B3', 'B4', 'C1'],
        customStates: [
            'STATE_DMS_529CLE',
            'STATE_DMS_529ROG', 'STATE_DMS_583REJ',
            'STATE_DMS_582REM', 'STATE_DMS_531REM',
            'STATE_DMS_528ACC', // added
        ],
    },
    PRE: {
        decTypes: ['D', 'E', 'F'],
        procedures: ['B1', 'B2', 'B3', 'B4', 'C1'],
        customStates: [
            'STATE_DMS_REG',
            'STATE_DMS_511REJ', 'STATE_DMS_560CTL10-50'
        ],
    },
    'PCS-NLRTM-MED': {
        decTypes: null,
        procedures: ['B1', 'B2', 'B3', 'B4', 'C1'],
        customStates: [
            'STATE_DMS_529CLE',
            'STATE_DMS_529ROG', 'STATE_DMS_583REJ',
            'STATE_DMS_582REM', 'STATE_DMS_531REM'
        ]
    },
    EMERGENCY: {
        decTypes: null,
        procedures: ['B1', 'B2', 'B3', 'B4', 'C1'],
        customStates: [],
        customStatesExcept: [
            'STATE_DMS_529ROG', 'STATE_DMS_529CLE', 'STATE_DMS_599EXIT',
            'STATE_DMS_582REM', 'STATE_DMS_583SENT', 'STATE_DMS_583REJ',
            'STATE_DMS_528ACC'
        ]
    }
})


export const fileTypeMapping = () => ([
    {
      FORM_TYPE: 'IE515',
      PROCEDURES: ['B1', 'B2', 'B3', 'B4'],
      TRANS_TYPES: ['NEW','EMERGENCY'],
      DEC_TYPES: ['A'],
      SHIPMENT_TYPE:['EXPORT']
    },
    {
      FORM_TYPE: 'IE583',
      PROCEDURES: ['B1', 'B2', 'B3', 'B4'],
      TRANS_TYPES: ['EXT'],
      DEC_TYPES: ['A'],
      SHIPMENT_TYPE:['EXPORT']
    },
    {
      FORM_TYPE: 'NLCRE',
      PROCEDURES: ['B1', 'B2', 'B3', 'B4'],
      TRANS_TYPES: ['CRE'],
      DEC_TYPES: ['A'],
      SHIPMENT_TYPE:['EXPORT']
    },
    {
        FORM_TYPE: 'IE415',
        PROCEDURES: ['H1'],
        TRANS_TYPES: ['NEW','EMERGENCY'],
        DEC_TYPES: ['A'],
        SHIPMENT_TYPE:['IMPORT']
    },
  ])